export enum ParticipantProviderId {
  Scoresway = 12,
}
